"use client";
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showError = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var CloseOutlined_1 = __importDefault(require("@mui/icons-material/CloseOutlined"));
var joy_1 = require("@mui/joy");
var react_1 = require("react");
var ErrorContext_1 = require("./ErrorContext");
var ErrorProvider = /** @class */ (function (_super) {
    __extends(ErrorProvider, _super);
    function ErrorProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.showError = function (msg, stack) {
            _this.setState({ error: msg, stack: stack });
        };
        exports.showError = _this.showError;
        _this.state = {
            error: "",
            contextValue: {
                showError: _this.showError.bind(_this),
            }
        };
        return _this;
    }
    ErrorProvider.prototype.render = function () {
        var _this = this;
        var _a = this.state, error = _a.error, stack = _a.stack, contextValue = _a.contextValue;
        var handleClose = function () {
            _this.setState({ error: "" });
        };
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ErrorContext_1.ErrorContext.Provider, { value: contextValue }), !!error &&
                    (0, jsx_runtime_1.jsx)(joy_1.Modal, { open: true, children: (0, jsx_runtime_1.jsxs)(joy_1.ModalDialog, { children: [(0, jsx_runtime_1.jsxs)(joy_1.DialogTitle, { sx: { paddingTop: 3, paddingBottom: .5 }, children: [(0, jsx_runtime_1.jsx)(joy_1.IconButton, { size: "sm", onClick: function (e) { return handleClose(); }, sx: { position: 'absolute', right: 8, top: 8 }, children: (0, jsx_runtime_1.jsx)(CloseOutlined_1.default, { fontSize: "small" }) }), "Error"] }), (0, jsx_runtime_1.jsxs)(joy_1.DialogContent, { children: [(0, jsx_runtime_1.jsx)(joy_1.Typography, { children: error }), stack && stack != error &&
                                            (0, jsx_runtime_1.jsx)(joy_1.Box, { mt: 2, children: (0, jsx_runtime_1.jsx)(joy_1.AccordionGroup, { variant: "outlined", children: (0, jsx_runtime_1.jsxs)(joy_1.Accordion, { children: [(0, jsx_runtime_1.jsx)(joy_1.AccordionSummary, { children: "Stack Trace" }), (0, jsx_runtime_1.jsx)(joy_1.AccordionDetails, { children: (0, jsx_runtime_1.jsx)(joy_1.Sheet, { color: "neutral", variant: "soft", children: (0, jsx_runtime_1.jsx)(joy_1.Box, { p: 1, children: (0, jsx_runtime_1.jsx)(joy_1.Typography, { component: "div", level: "body-sm", mt: 1, fontFamily: "monospace", fontSize: "12px", position: "relative", children: (0, jsx_runtime_1.jsx)("pre", { style: { whiteSpace: "pre-wrap", wordWrap: "break-word" }, children: stack }) }) }) }) })] }) }) })] })] }) })] }));
    };
    return ErrorProvider;
}(react_1.Component));
exports.default = ErrorProvider;
